var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preOrder)?_c('NewPreOrderUnit',{attrs:{"manufacturers":_vm.manufacturers},on:{"searchManufacturers":_vm.executeManufacturerSearch,"addUnit":_vm.addUnit,"cancel":_vm.cancel}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }